import { useEffect } from 'react';
import { useSearchParams } from '@remix-run/react';

export default function PromotionHandler() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Check for promotion parameter in URL
    const promotionCode = searchParams.get('promotion');
    
    if (promotionCode) {
      // Set cookie with promotion code - expires in 7 days
      const expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 7);
      
      document.cookie = `promotionCode=${encodeURIComponent(promotionCode)};path=/;expires=${expirationDate.toUTCString()};SameSite=Lax`;
      
      console.log('Promotion code saved:', promotionCode);
    }
  }, [searchParams]);

  return null; // This component doesn't render anything
}